import styled from '@emotion/styled';
import { Alert } from 'antd';
import { ACCOUNT_STATUS_CODE, BREAKPOINT } from 'utilities/constants';
import ClosedStatusFields from '../ClosedStatusFields';
import { FORM_FIELD } from './applyStatusConstants';

export const StatusDetailsGrid = styled.div(() => {
  return `
    display: grid;
    grid-gap: 0 var(--spacing);
    grid-template-columns: 1fr;

    @media (min-width: ${BREAKPOINT.LG_PX}) {
      grid-template-columns: 1fr 1fr;
    }
  `;
});

export const renderStatusFields = ({
  blockingStatusMessage,
  currentViewedAccount,
  form,
  highlightBlockingStatusMessage,
}) => {
  if (blockingStatusMessage) {
    return (
      <Alert
        banner
        type={highlightBlockingStatusMessage ? 'error' : 'warning'}
        title={blockingStatusMessage}
        style={{ marginBottom: 'var(--spacing)', gridColumn: '1/-1' }}
      />
    );
  }

  const statusCode = form.getFieldValue(FORM_FIELD.STATUS_CODE);

  if (statusCode === ACCOUNT_STATUS_CODE.CLOSED) {
    return <ClosedStatusFields account={currentViewedAccount} form={form} />;
  }
};
